// extracted by mini-css-extract-plugin
module.exports = {"container":"_3j3sBnIHbhd1hBELBQ5KqN","groupsList":"_3wLGl1MMORtOF0ktGR_oXc"};